export default "__VITE_ASSET__Bh0Tz3s$__"